export const cilClone = ["24 24","<path d='M22.125 0.75h-14.625c-0.621 0.001-1.124 0.504-1.125 1.125v14.625c0.001 0.621 0.504 1.124 1.125 1.125h14.625c0.621-0.001 1.124-0.504 1.125-1.125v-14.625c-0.001-0.621-0.504-1.124-1.125-1.125h-0zM21.75 16.125h-13.875v-13.875h13.875z'></path><path d='M16.125 21.75h-13.875v-13.875h2.625v-1.5h-3c-0.621 0.001-1.124 0.504-1.125 1.125v14.625c0.001 0.621 0.504 1.124 1.125 1.125h14.625c0.621-0.001 1.124-0.504 1.125-1.125v-3h-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-clone.js
// module id = null
// module chunks = 